<template>
	<header>
		<nav class="uk-navbar-container" uk-navbar="mode: click">
			<div class="uk-navbar-left left-menu-icon-wrapper">
				<div class="left-menu-icon">
					<a class="uk-navbar-toggle" uk-navbar-toggle-icon href="#" uk-toggle="target: #offcanvas-nav"></a>
				</div>
			</div>

<!--			mobile menu-->
			<div id="offcanvas-nav" uk-offcanvas>
				<div class="uk-offcanvas-bar left-menu">
					<button class="uk-offcanvas-close" type="button" uk-close></button>
					<div class="offcanvas-logo">
						<img :src="require('@/assets/img/logo.png')" alt=""/>
					</div>
					<ul class="uk-nav-default uk-nav-parent-icon" uk-nav="multiple: false; animation: false;">
						<li>
							<a v-access:can="[Const.PERMISSION_ROLE_BASE]" href="/item-table">{{ $t('catalogue')
								}}</a>
						</li>
            <li><a href="/dashboard">{{ $t('dashboard') }}</a></li>
						<li class="uk-parent"
							v-access:can="[Const.PERMISSION_ROLE_EXPORT,Const.PERMISSION_ROLE_IMPORT]">
							<a href="#">{{ $t('history') }}</a>
							<ul class="uk-nav-sub">
								<li v-access:can="[Const.PERMISSION_ROLE_EXPORT]">
									<a href="/export-history">{{ $t('export.history') }}</a>
								</li>
								<li v-access:can="[Const.PERMISSION_ROLE_IMPORT]">
									<a href="/import-history">{{ $t('import.history') }}</a>
								</li>
								<li>
									<a href="/item-table?mode=deleted">{{ $t('deleted.items') }}</a>
								</li>
							</ul>
						</li>
						<li class="uk-parent"
							v-access:can="[Const.PERMISSION_ROLE_MANAGER,Const.PERMISSION_ROLE_EXPORT_IMPORT_CONFIGURATION]">
							<a href="#" v-t="'company.setup'"></a>
							<ul class="uk-nav-sub">
								<li v-access:can="[Const.PERMISSION_ROLE_MANAGER]"><a href="/company"
																					  v-t="'company.profile'"></a>
								</li>
								<li v-access:can="[Const.PERMISSION_ROLE_MANAGER]"><a href="/company/users">{{
									$t('users') }}</a></li>
								<li v-access:can="[Const.PERMISSION_ROLE_MANAGER]"><a href="/company/roles">{{
									$t('roles') }}</a></li>
								<li v-access:can="[Const.PERMISSION_ROLE_MANAGER]"><a href="/company/groups">{{
									$t('groups') }}</a></li>
								<li v-access:can="[Const.PERMISSION_ROLE_MANAGER]"><a href="/company/notifications">{{
									$t('notifications') }}</a>
								<li v-access:can="[Const.PERMISSION_ROLE_MANAGER]"><a href="/company/notification-templates">{{
										$t('notification.templates') }}</a>
								</li>
								<li v-access:can="[Const.PERMISSION_ROLE_MANAGER]"><a href="/company/attributes">{{
									$t('attributes') }}</a></li>

								<li v-access:can="[Const.PERMISSION_ROLE_EXPORT_IMPORT_CONFIGURATION]"><a
									href="/export-configurations">{{
									$t('export.configurations') }}</a>
								</li>
								<li v-access:can="[Const.PERMISSION_ROLE_EXPORT_IMPORT_CONFIGURATION]"><a
									href="/import-configurations">{{
									$t('import.configurations') }}</a>
								</li>
								<li v-access:can="[Const.PERMISSION_ROLE_EXPORT_IMPORT_CONFIGURATION]"><a
									href="/migration-resources">{{
									$t('configuration.resources') }}</a>
								</li>
								<li v-access:can="[Const.PERMISSION_ROLE_EXPORT_IMPORT_CONFIGURATION]"><a
									href="/tag-management">{{
									$t('tag.management') }}</a>
								</li>

								<li v-access:can="[Const.PERMISSION_ROLE_MANAGER, Const.PERMISSION_ROLE_ADMIN]"><a
									@click="downloadDatamodel('/datamodel/excel')" v-t="'company.datamodel'"></a></li>
								<li v-access:can="[Const.PERMISSION_ROLE_MANAGER, Const.PERMISSION_ROLE_ADMIN]"><a
									href="/item-structure">{{ $t('item.structure') }}</a></li>
							</ul>
						</li>
						<li class="uk-parent" v-access:can="[Const.PERMISSION_ROLE_ADMIN]">
							<a href="#">{{ $t('administration') }}</a>
							<ul class="uk-nav-sub">
								<li><a href="/companies">{{ $t('companies') }}</a></li>
								<li><a href="/users">{{ $t('users') }}</a></li>
								<li><a href="/global-roles">{{ $t('roles') }}</a></li>
								<li><a href="/global-groups">{{ $t('groups') }}</a></li>
								<li><a href="/global-notification-templates">{{ $t('notification.templates') }}</a></li>
								<li><a href="/global-export-configurations">{{
									$t('export.configurations') }}</a></li>
								<li><a href="/global-import-configurations">{{
									$t('import.configurations') }}</a></li>
								<li><a href="/global-migration-resources">{{ $t('configuration.resources') }}</a>
								</li>
								<li><a href="/global-tag-management">{{ $t('tag.management') }}</a></li>
								<li><a href="/translation">{{ $t('localization.management') }}</a></li>
							</ul>
						</li>
            <li><a :href="docuEdiUrl">Docu-EDI</a></li>
					</ul>
				</div>
			</div>

			<a class="uk-navbar-item uk-logo header-logo" href="/">
				<img :src="require('@/assets/img/logo.png')" alt=""/>
			</a>
			<div class="main-menu">
				<div class="uk-navbar-left">
					<ul class="uk-navbar-nav">
            <li>
              <a v-access:can="[Const.PERMISSION_ROLE_BASE]" href="/item-table">{{ $t('catalogue') }}</a>
            </li>
						<li><a href="/dashboard">{{ $t('dashboard') }}</a></li>
						<li v-access:can="[Const.PERMISSION_ROLE_EXPORT,Const.PERMISSION_ROLE_IMPORT]">
							<a href="#">{{ $t('history') }}</a>
							<div class="uk-navbar-dropdown navigations-menu" uk-drop="mode: hover;">
								<ul class="uk-nav uk-navbar-dropdown-nav">
									<li v-access:can="[Const.PERMISSION_ROLE_EXPORT]">
										<a href="/export-history">{{ $t('export.history') }}</a>
									</li>
									<li v-access:can="[Const.PERMISSION_ROLE_IMPORT]">
										<a href="/import-history">{{ $t('import.history') }}</a>
									</li>
									<li>
										<a href="/item-table?mode=deleted">{{ $t('deleted.items') }}</a>
									</li>
								</ul>
							</div>
						</li>
						<li v-access:can="[Const.PERMISSION_ROLE_MANAGER,Const.PERMISSION_ROLE_EXPORT_IMPORT_CONFIGURATION]">
							<a href="#" v-t="'company.setup'"></a>
							<div class="uk-navbar-dropdown navigations-menu" uk-drop="mode: hover;">
								<ul class="uk-nav uk-navbar-dropdown-nav">
									<li v-access:can="[Const.PERMISSION_ROLE_MANAGER]"><a href="/company"
																						  v-t="'company.profile'"></a>
									</li>
									<li v-access:can="[Const.PERMISSION_ROLE_MANAGER]"><a href="/company/users">{{
										$t('users') }}</a></li>
									<li v-access:can="[Const.PERMISSION_ROLE_MANAGER]"><a href="/company/roles">{{
										$t('roles') }}</a></li>
									<li v-access:can="[Const.PERMISSION_ROLE_MANAGER]"><a href="/company/groups">{{
											$t('groups') }}</a></li>
									<li v-access:can="[Const.PERMISSION_ROLE_MANAGER]"><a href="/company/notifications">{{
										$t('notifications') }}</a>
									<li v-access:can="[Const.PERMISSION_ROLE_MANAGER]"><a href="/company/notification-templates">{{
										$t('notification.templates') }}</a>
									</li>
									<li v-access:can="[Const.PERMISSION_ROLE_MANAGER]"><a href="/company/attributes">{{
										$t('attributes') }}</a></li>

									<li v-access:can="[Const.PERMISSION_ROLE_EXPORT_IMPORT_CONFIGURATION]"><a
										href="/export-configurations">{{
										$t('export.configurations') }}</a>
									</li>
									<li v-access:can="[Const.PERMISSION_ROLE_EXPORT_IMPORT_CONFIGURATION]"><a
										href="/import-configurations">{{
										$t('import.configurations') }}</a>
									</li>
									<li v-access:can="[Const.PERMISSION_ROLE_EXPORT_IMPORT_CONFIGURATION]"><a
										href="/migration-resources">{{
										$t('configuration.resources') }}</a>
									</li>
									<li v-access:can="[Const.PERMISSION_ROLE_EXPORT_IMPORT_CONFIGURATION]"><a
										href="/tag-management">{{
										$t('tag.management') }}</a>
									</li>

									<li v-access:can="[Const.PERMISSION_ROLE_MANAGER, Const.PERMISSION_ROLE_ADMIN]"><a
										@click="downloadDatamodel('/datamodel/excel')" v-t="'company.datamodel'"></a>
									</li>
									<li v-access:can="[Const.PERMISSION_ROLE_MANAGER, Const.PERMISSION_ROLE_ADMIN]"><a
										href="/item-structure">{{ $t('item.structure') }}</a></li>
								</ul>
							</div>
						</li>
						<li v-access:can="[Const.PERMISSION_ROLE_ADMIN]">
							<a href="#">{{ $t('administration') }}</a>
							<div class="uk-navbar-dropdown navigations-menu" uk-drop="mode: hover;">
								<ul class="uk-nav uk-navbar-dropdown-nav">
									<li><a href="/companies">{{ $t('companies') }}</a></li>
									<li><a href="/users">{{ $t('users') }}</a></li>
									<li><a href="/global-roles">{{ $t('roles') }}</a></li>
									<li><a href="/global-groups">{{ $t('groups') }}</a></li>
									<li><a href="/global-notification-templates">{{ $t('notification.templates') }}</a></li>
									<li><a href="/global-export-configurations">{{
										$t('export.configurations') }}</a></li>
									<li><a href="/global-import-configurations">{{
										$t('import.configurations') }}</a></li>
									<li><a href="/global-migration-resources">{{ $t('configuration.resources') }}</a>
									</li>
									<li><a href="/global-tag-management">{{ $t('tag.management') }}</a></li>
									<li><a href="/translation">{{ $t('localization.management') }}</a></li>
								</ul>
							</div>
						</li>
            <li><a :href="docuEdiUrl">Docu-EDI</a></li>
					</ul>
				</div>
			</div>
			<div class="small-main-menu">
				<div class="uk-navbar-left">
					<ul class="uk-navbar-nav">
						<li>
							<a id="current-company_left-menu" href="#"></a>
							<div class="uk-navbar-dropdown company_list switch-company_left-menu" uk-drop="mode: click;">
								<input type="text" autofocus class="textInput attribute-editor uk-margin-small-bottom" :placeholder="$t('search')" v-model="searchCompany">
								<button class="button_reset fa fa-times" @click="searchCompany = ''"></button>
								<ul class="uk-nav uk-navbar-dropdown-nav">
									<li v-for="company in companyFindedList" :key="company.id"
										:value="company.id" @click="selectedCompany(company.id)"><a>{{ company.name }}</a></li>
								</ul>
							</div>
						</li>
						<li>
							<a href="#" class="icon-menu" uk-icon="chevron-down"></a>
							<div class="uk-navbar-dropdown">
								<div class="service-menu">
									<nav class="uk-navbar-container uk-margin uk-navbar-transparent"
										 uk-navbar="mode: click;">
										<div class="uk-navbar-left">
											<ul class="uk-list">
												<li>
													<a class="current-user" :href="docuIdUrl + '/profile'">
														{{ $t('profile') }}
													</a>
												</li>
												<li>
													<Languages/>
												</li>
												<hr class="navbar-line"/>
												<li><a @click="logout">{{ $t('logout') }}</a></li>
											</ul>
										</div>
									</nav>
								</div>
							</div>
						</li>
					</ul>
				</div>
			</div>
			<div class="main-menu-profile">
				<div class="uk-navbar-right">
					<ul class="uk-navbar-nav">
						<li class="uk-active">
							<a id="current-company"></a>
							<div class="uk-navbar-dropdown company_list">
								<input type="text" autofocus class="textInput attribute-editor uk-margin-small-bottom" :placeholder="$t('search')" v-model="searchCompany">
								<button class="button_reset fa fa-times" tabindex="-1" @click="searchCompany = ''"></button>
								<ul class="uk-nav uk-navbar-dropdown-nav switch-company">
									<li v-for="company in companyFindedList" :key="company.id" :value="company.id" tabindex="0" @click="selectedCompany(company.id)" v-on:keyup.enter="selectedCompany(company.id)"><a>{{
										company.name }}</a></li>
								</ul>
							</div>
						</li>
						<Languages :wrapper="false"/>
						<li>
							<a href="#" uk-icon="user" class="user-profile"></a>
							<div class="uk-navbar-dropdown">
								<ul class="uk-nav uk-navbar-dropdown-nav">
									<li>
										<a class="current-user" :href="docuIdUrl + '/profile'">
											{{ $t('profile') }}
										</a>
									</li>
									<hr class="navbar-line"/>
									<li @click="logout"><a href="#">{{ $t('logout') }}</a></li>
								</ul>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</nav>
	</header>
</template>

<script>
import { REQUEST_PERMISSIONS, USER_REQUEST } from 'actions/user'
import { FULL_LOGOUT } from 'actions/authentication'
import Languages from 'components/languages-switch/Languages'
import { downloadManager } from 'utils/download'
import { ClientSessionManager } from '@/core/administration/ClientSessionManager'
import { initHeaderMenu, initHeaderSelectCompanyForm } from '@/core/core_components/header/header'
import { CONFIGURATIONS_INIT } from 'actions/configurations'

export default {
	name: 'mw-header',
	components: {
		Languages
	},
	data () {
		return {
			companyId: this.$store.getters.getProfile.companyId || null,
			companyList: this.$store.getters.getCompanyList || [],
			userId: this.$store.getters.getProfile.id || null,
			docuEdiUrl: process.env.VUE_APP_DOCU_EDI_URL,
			docuIdUrl: process.env.VUE_APP_DOCU_ID_URL,
			searchCompany: '',
			isVisibleModal: false
		}
	},
	computed: {
		companyFindedList: function () {
			return this.companyList.filter(c => String(c.name).toLowerCase().indexOf(this.searchCompany.toLowerCase()) > -1)
		}
	},
	methods: {
		initData: function () {
			this.$store.dispatch(USER_REQUEST)
				.then((res) => {
					this.companyId = res.userProfile.companyId
					this.companyList = res.companyList
					this.userId = res.userProfile.id
				})
				.then(() => {
					this.initCompanyList()
				})
		},
		initCompanyList: function () {
			const vm = this
			if (typeof window.ClientSessionManager === 'function' || window.ClientSessionManager === undefined) {
				window.ClientSessionManager = new ClientSessionManager(this.companyId)
			}
			$('.company_list li[value="' + this.companyId + '"]').addClass('uk-active')
			initHeaderSelectCompanyForm()
			initHeaderMenu()

			UIkit.util.on('.company_list', 'hide', function () {
				vm.searchCompany = ''
			});
		},
		selectedCompany: function (companyId) {
			window.ClientSessionManager.submitSelectedCompany(companyId, this.updateProfile)
		},
		updateProfile: function (data) {
			this.$store.dispatch(USER_REQUEST)
				.then(async () => {
					await this.$store.commit('CONFIGURATIONS_CLEAR')
					await this.$store.dispatch(CONFIGURATIONS_INIT)
					await this.$store.dispatch(REQUEST_PERMISSIONS).then(() => {
						document.location.href = '/' + data
					})
				})
		},
		logout: function () {
			this.$store.dispatch(FULL_LOGOUT)
		},
		downloadDatamodel: function (url) {
			return downloadManager(url)
		}
	},
	mounted () {
		if (this.$store.getters.getCompanyList.length === 0) {
			this.initData()
		} else {
			this.initCompanyList()
		}
	}
}
</script>

<style lang="scss" scoped>
.navbar-line {
	margin: 8px 0;
}
.company_list {
	max-height: calc(100vh - 100px);
	overflow-y: auto;
	position: fixed;
	li:focus-visible {
		background-color: #f8f8f8;
		outline: none;
		a {
			color: #0090D0;
		}
	}
}
</style>
